import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchCustomers } from '../services/customers';

interface UseCustomersQueryParams {
    search?: string;
}

export const customerKeys = {
    all: ['customers'] as const,
    lists: () => [...customerKeys.all, 'list'] as const,
    list: (filters: UseCustomersQueryParams) => [...customerKeys.lists(), filters] as const,
    byId: (id: string) => [...customerKeys.all, 'byId', id] as const,
};

export const useCustomersQuery = (params: UseCustomersQueryParams = {}) => {
    const query = useQuery({
        queryKey: customerKeys.list(params),
        queryFn: () => fetchCustomers(params),
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes
        retry: 2,
        // Only fetch when there's a search term (data protection requirement)
        enabled: !!params.search && params.search.length >= 2,
    });

    useEffect(() => {
        if (query.isError) {
            console.error('Failed to fetch customers:', query.error);
        }
    }, [query.isError, query.error]);

    return query;
};
